var t=function(t){t.stopPropagation()},n=function(t){t.ctrlKey&&t.preventDefault()},o=function(){return""};export{n as preventScroll,o as renderNothing,t as stopPropagationToParent};
